import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const ProvinciaFormGroup = ({ iError, iTouched, fIsSubmitting, vIdDepartamento }) => {
  const [pronvincias, setProvincias] = React.useState([])

  React.useEffect(() => {
    if (vIdDepartamento) {
      TablaComunService.getAsSelect(TiposTablaComunConstant.PROVINCIA, {
        _idDepartamento: vIdDepartamento
      }).then(({ data }) => setProvincias(data))
    } else {
      setProvincias([])
    }
  }, [vIdDepartamento])

  return (
    <Form.Group>
      <Form.Label text='PROVINCIA' htmlFor='select-idProvincia' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idProvincia'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-idProvincia'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {pronvincias.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProvinciaFormGroup)
